import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fcp-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
    @Input() castNoShadow: boolean;
    @Input() img: string;
    @Input() title: string;
    @Input() description: string;
    @Input() modal: string;
    @Input() link: string;
    @Input() linkDescription: string;

    constructor() { }

    ngOnInit() { }

}
